import { Grid } from '@mui/material';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Configurations from '../../components/configurations';
import ConfigLayout from '../../layout/dashboard/ConfigLayout';
import { useProject } from '../../context/ProjectContext';

const ConfigurationContent = ({ selectedTab }) => {
  const { projectUser } = useProject();

  return (
    <Grid container spacing={2}>
      <Grid item md={12}>
        <Configurations selectedTab={selectedTab} user={projectUser || {}} />
      </Grid>
    </Grid>
  );
};

const ConfigurationPage = () => {
  const location = useLocation();
  const { tab } = queryString.parse(location.search);
  const [selectedTab, setSelectedTab] = useState(tab || 'environments');

  useEffect(() => {
    if (tab) {
      setSelectedTab(tab);
    }
  }, [tab]);

  return (
    <ConfigLayout selectedTab={selectedTab} setSelectedTab={setSelectedTab}>
      <ConfigurationContent selectedTab={selectedTab} />
    </ConfigLayout>
  );
};

export default ConfigurationPage;
